<template>
  <div id="body">
    <img id="logo" :src="require('@/assets/imgs/logo-black.png')" @click="toHome()" />
    <article class="container">
      <div v-if="!sent">
        <h1>Get your account back</h1>
        <div id="content">
          <label class="pure-material-textfield-outlined">
            <input
              class="form-control"
              type="email"
              v-model="email"
              @keyup="checkUserEmail"
              placeholder=" "
            />
            <span>Email</span>
            <p class="error-message">{{email_message || "&nbsp;"}}</p>
          </label>
          <div>
            <button @click="sendPasswordReset" class="btn color-btn">Send Reset Email</button>
            <p class="error-message">{{login_error || "&nbsp;"}}</p>
          </div>

          <p>You will receive an email with a link to reset your password</p>
        </div>
      </div>
      <div v-else>
        <p
          style="margin-top:2rem; font-size:1.2rem;"
        >Check your inbox for a link to reset your password</p>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      email_message: "",
      sent: false,
      login_error: ""
    };
  },

  methods: {
    toHome() {
      this.$router.push({ name: "advertising-page" });
    },

    checkUserEmail() {
      if (!this.checkEmailFormat(this.email)) {
        this.email_message = "*Invalid email format";
      } else {
        this.email_message = "";
      }
    },

    sendPasswordReset() {
      this.checkUserEmail();
      if (!this.email_message) {
        this.$store
          .dispatch("sendPasswordReset", this.email)
          .then(message => {
            this.email_message = "A link has been sent to your email";
            this.sent = true;
          })
          .catch(err => {
            console.log(err.response);
            this.login_error = err.response.data.message;
          });
      }
    }
  }
};
</script>

<style scoped>
* {
  font-family: Jura;
  font-weight: bold;
}

#body {
  background: url("../../assets/imgs/purewhite_curveline.png") no-repeat center
    fixed;
  background-size: cover;
  min-height: 100vh;
}

h1 {
  margin-top: 5rem;
  margin-bottom: 2rem;
  text-align: center;
  font-family: Jura;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: 1.41px;
  color: #4a4a4a;
}

#content {
  max-width: 30rem;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: auto;
}

.btn {
  width: 100%;
}

p {
  font-size: 20px;
}

p span {
  color: #f5a623;
  text-decoration: underline;
}

p > span:hover {
  cursor: pointer;
}

#logo {
  width: 10rem;
  height: 36px;
  margin-left: 3rem;
  margin-top: 1rem;
  cursor: pointer;
}

.color-btn {
  color: black;
  background: #f5a623;
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #ffffff;
}

p {
  text-align: center;
}

.error-message {
  font-size: 16px;
  color: red;
  margin-left: 2px;
  text-align: left;
}

/* css effects for input */

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  /* margin: 10px auto; */
  display: block;
  padding-top: 6px;
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  /* border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  /* color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined
      > input
      + span
      .pure-material-textfield-outlined
      > input
      + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.1s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/static/reset-password-page.vue